import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {RecordContactType} from "@shared/api/models/query/patient-record-appointment-note.model";

@Injectable({
    providedIn: 'root'
})
export class RecordContactTypeService extends PaginatorService<RecordContactType> {

    protected override get domainEntity() {
        return 'lists/record-contact-types';
    };
}
